import { recordPage, recordEventCustomOnly } from 'utilities/uTagging';
import { SECTION_TYPE } from '../constants';
import { getGA4EventKeys } from 'utilities/ga4';

const { PERSONAL_DATA, PRECONTRACTUAL_DOCS, EMAIL_OTP_VALIDATION, ACCESS_DATA } = SECTION_TYPE;

const section = {
    [PERSONAL_DATA]: {
        event_name: 'step_personalData',
        pageName: 'onboarding/step1/personalData',
        processStep: 'step1',
        processDetail: 'personalData',
        nombrePagina: '/onboarding/abre-tu-cuenta/datos personales',
        detalleProceso: 'datos personales',
        edit: 'modifyPersonalData',
    },
    [PRECONTRACTUAL_DOCS]: {
        event_name: 'step_readAndAcceptTheDocuments',
        pageName: 'onboarding/step2/readAndAcceptTheDocuments',
        processStep: 'step2',
        processDetail: 'readAndAcceptTheDocuments',
        nombrePagina: '/onboarding/abre-tu-cuenta/lee y acepta los documentos',
        detalleProceso: 'lee y acepta los documentos',
        edit: 'reviewReadAndAcceptTheDocuments',
    },
    [EMAIL_OTP_VALIDATION]: {
        event_name: 'step_validateEmail',
        pageName: 'onboarding/step3/validateEmail',
        processStep: 'step3',
        processDetail: 'validateEmail',
        nombrePagina: '/onboarding/abre-tu-cuenta/valida tu email',
        detalleProceso: 'valida tu email',
        edit: 'modifyValidateEmail',
    },
    [ACCESS_DATA]: {
        event_name: 'step_accessKey',
        pageName: 'onboarding/step4/accessKey',
        processStep: 'step4',
        processDetail: 'accessKey',
        nombrePagina: '/onboarding/abre-tu-cuenta/datos de acceso',
        detalleProceso: 'datos de acceso',
    },
};

export const doTagCurrentSection = ({
    type,
    isCollapsed,
    promoCode,
    jointHolderInfo,
    investmentType,
    identificadorOnboarding,
    userId,
}) => {
    if (!isCollapsed) {
        const pageName = section[type].pageName;
        recordPage(
            section[type].nombrePagina,
            undefined,
            userId,
            undefined,
            undefined,
            promoCode,
            jointHolderInfo,
            undefined,
            undefined,
            investmentType,
            {
                ...getGA4EventKeys({
                    eventName: section[type].event_name,
                    pageName,
                    processDetail: section[type].processDetail,
                    onboardingType: investmentType,
                    typeHolder: jointHolderInfo.typeHolder,
                }),
                processStep: section[type].processStep,
                tipoProceso: 'onboarding',
                pasoProceso: 'abre tu cuenta',
                detalleProceso: section[type].detalleProceso,
                identificadorOnboarding,
            }
        );

        return pageName;
    }
};

export const doTagCurrentSectionButton = type => {
    recordEventCustomOnly({
        action: 'click',
        format: 'button',
        component: 'form',
        element: 'next',
        eventCategory: section[type].pageName,
        eventAction: 'clickButton',
        eventLabel: 'nextButton',
    });
};

export const doTagCurrentSectionEdit = type => {
    recordEventCustomOnly({
        action: 'click',
        format: 'link',
        component: 'form',
        element: section[type].edit,
        eventCategory: section[type].pageName,
        eventAction: 'clickLink',
        eventLabel: section[type].edit,
    });
};
